var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h3',{staticClass:"text-capitalize"},[_vm._t("before"),_c('span',{staticClass:"d-block-inline",domProps:{"innerHTML":_vm._s(_vm.title)}}),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }